// 加密方法
import CryptoJS from 'crypto-js'

// 加密加密
const keyOfKey = '1ea53d260ecf11e7b56e00163e046a26' // 加密的加密使用，防爬
const effectsKeyUn = 'JoiGwY5CFA14hRGCwiaZ8UpQEcZh5L+2' // 特效加密key
const effectsKey = decryptDES(effectsKeyUn, keyOfKey)

// DES解密函数
function decryptDES(ciphertext: string, key: string) {
  // 将密钥转换为WordArray格式
  const keyHex = CryptoJS.enc.Utf8.parse(key)

  // 使用DES算法进行解密，输出为明文
  const decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB, // 选择解密模式
      padding: CryptoJS.pad.Pkcs7 // 选择填充方式
    }
  )

  // 返回明文的UTF-8编码格式
  return decrypted.toString(CryptoJS.enc.Utf8)
}
export default {
  keyOfKey,
  decryptDES,
  effectsKey
}
